/**
 * Centralized Route Constants
 * Eliminates magic strings and provides consistent routing across the application
 */

// =============================================================================
// APP ROUTES (Frontend Application Routes)
// =============================================================================

export const APP_ROUTES = {
  // Main app routes
  LOGIN: '/login',
  HOME: '/home',
  DISCOVERY: '/discovery',
  DISCOVERY_STUDIOS: '/discovery?tab=studios',
  DISCOVERY_INSTRUCTORS: '/discovery?tab=instructors',
  DISCOVERY_CLASSES: '/discovery?tab=classes',
  DISCOVERY_STUDIOS_LIST: '/discovery/studios',
  DISCOVERY_STUDIOS_MAP: '/discovery/studios/map',
  LISTINGS: '/listings',
  COMMUNITY: '/community',
  COMMUNITY_CREATE_POST: '/community/create-post',
  COMMUNITY_POST_DETAIL: '/community/posts/$postId',
  COMMUNITY_POST_EDIT: '/community/posts/$postId/edit',
  PROFILE: '/profile',
  PROFILE_SETTINGS: '/profile/settings',
  PROFILE_EDIT: '/profile/edit',
  MARKET: '/market',
  MARKET_DETAIL: '/market/$productId',
  PURCHASE_DETAIL: '/purchase/$purchaseId',
  PROFILE_PURCHASES: '/profile/purchases',
  PROFILE_PURCHASE_DETAIL: '/profile/purchases/$purchaseId',
  SETTINGS: '/settings',
  ANALYTICS: '/analytics',
  FEATURE_REQUESTS: '/feature-requests',
  FEATURE_REQUESTS_NEW: '/feature-requests/new',
  DATA_REPORTS_NEW: '/data-reports/new',
  FEATURE_REQUESTS_DETAIL: '/feature-requests/$featureRequestId',
  FEATURE_REQUESTS_EDIT: '/feature-requests/edit/$featureRequestId',

  // Detail routes (Route IDs)
  INSTRUCTOR_DETAIL: '/instructors/$instructorId',
  STUDIO_DETAIL: '/studios/$studioId',
  CLASS_DETAIL: '/class/$classId',

  // Admin routes
  ADMIN: {
    BASE: '/admin',
    DATA_PIPELINE: '/admin/data-pipeline',
    CRAWL: '/admin/data-pipeline/crawl',
  },

  // Profile tabs
  PROFILE_TABS: {
    FAVORITES: 'favorites',
    REVIEWS: 'reviews',
    SOCIAL_POSTS: 'social-posts',
  } as const,

  // Profile social posts sub-tabs
  PROFILE_SOCIAL_SUBTABS: {
    MINE: 'mine',
    LIKED: 'liked',
  } as const,

  // Profile favorites sub-tabs
  PROFILE_FAVORITE_SUBTABS: {
    STUDIOS: 'studios',
    INSTRUCTORS: 'instructors',
  } as const,
} as const;

// =============================================================================
// STATIC ROUTES (Landing Pages, etc.)
// =============================================================================

export const STATIC_ROUTES = {
  // Root routes
  ROOT: '/',
  OFFLINE: '/offline',
  UNAUTHORIZED: '/unauthorized',

  // Dance landing pages
  DANCE: {
    BASE: '/dance',
    ABOUT: '/dance/about',
    FAQ: '/dance/faq',
    PAIN_POINTS: '/dance/pain-points',
    USER_TYPES: '/dance/user-types',
  },
} as const;
